import { Box, Typography, Avatar } from '@mui/material'
import { tokens } from '../../../theme'

export function StepItem({ number, text }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Avatar
        sx={{
          width: 24,
          height: 24,
          bgcolor: tokens.colors.primary.main,
          fontSize: 12,
          fontWeight: 600,
          fontFamily: tokens.typography.fontFamily.body,
        }}
      >
        {number}
      </Avatar>

      <Typography
        sx={{
          flex: 1,
          fontFamily: tokens.typography.fontFamily.body,
          fontSize: 14,
          color: tokens.colors.gray.text,
          lineHeight: 1.5,
        }}
      >
        {text}
      </Typography>
    </Box>
  )
}
